import moment from 'moment';
import { isEmpty } from 'ramda';
import { SubscriptionStatusCode } from 'constants/subscriptions';

export const findSubByReferenceOrStatus = ({ selectReference, subscriptions }) => {
  if (selectReference) {
    return subscriptions.find((s) => s.booking.reference === selectReference);
  }

  return (
    subscriptions.find((s) => s.status === SubscriptionStatusCode.ACTIVE) ||
    subscriptions.find((s) => s.status === SubscriptionStatusCode.NOT_STARTED) ||
    subscriptions.find((s) => s.status === SubscriptionStatusCode.PENDING_PAYMENT) ||
    subscriptions.find((s) => s.status === SubscriptionStatusCode.EXPIRED) ||
    subscriptions.find((s) => s.status === SubscriptionStatusCode.CANCELLED)
  );
};

export const getVATStatus = ({ nonCancelledSubscription, vatAlreadyRefunded, isNoVATProduct, intl }) => {
  if (!!nonCancelledSubscription && !isEmpty(nonCancelledSubscription)) {
    if (isNoVATProduct) {
      return `${intl.formatMessage({ id: 'subscriptions.notPaid' })}`;
    }

    return vatAlreadyRefunded
      ? `${intl.formatMessage({ id: 'subscriptions.vatRefunded' })}`
      : `${intl.formatMessage({ id: 'subscriptions.vatPaid' })}`;
  }

  return '-';
};

export const getDiscountCode = ({ booking }) => booking?.discounts?.[0]?.code;

export const getDateObjects = (bookingCreationDate, endDate, startDate) => ({
  daysDiffBetweenTodayAndBookingCreation: Math.abs(moment().diff(moment(bookingCreationDate), 'days', true)),
  daysDiffBetweenTodayAndStartDate: moment().diff(moment(startDate), 'days'),
  monthsPeriodOfSubscription: Math.ceil(Math.abs(moment(startDate).diff(moment(endDate), 'months', true))),
  monthsDiffBetweenTodayAndStartDate: Math.ceil(moment().diff(moment(startDate), 'months', true))
});

export const getCancellationFees = (price, bookingCreationDate, endDate, startDate) => {
  const {
    daysDiffBetweenTodayAndBookingCreation,
    monthsPeriodOfSubscription,
    monthsDiffBetweenTodayAndStartDate,
    daysDiffBetweenTodayAndStartDate
  } = getDateObjects(bookingCreationDate, endDate, startDate);

  const monthlyPrice = price / monthsPeriodOfSubscription;
  const roundedMonthlyPrice = Number((price / monthsPeriodOfSubscription).toFixed(2));
  const subscriptionPaidLessThan14DaysAgo = daysDiffBetweenTodayAndBookingCreation <= 14;

  if (subscriptionPaidLessThan14DaysAgo) {
    return 0;
  }

  if (monthsDiffBetweenTodayAndStartDate <= 1) {
    return daysDiffBetweenTodayAndStartDate <= 14 ? 0 : roundedMonthlyPrice;
  }

  return Math.min(Number((monthsDiffBetweenTodayAndStartDate * monthlyPrice).toFixed(2)), price);
};

export const cancellationMessage = (dateObject) => {
  if (dateObject.daysDiffBetweenTodayAndBookingCreation <= 14 || dateObject.daysDiffBetweenTodayAndStartDate <= 14) {
    return dateObject.monthsPeriodOfSubscription;
  }

  return dateObject.monthsDiffBetweenTodayAndStartDate > dateObject.monthsPeriodOfSubscription
    ? 0
    : Math.abs(dateObject.monthsDiffBetweenTodayAndStartDate - dateObject.monthsPeriodOfSubscription);
};

export const enableAfterSalesBasedOnConfirmedTimeStamp = ({ status, confirmedTimeStamp }) => {
  if (status === SubscriptionStatusCode.PENDING_PAYMENT) return true;
  return moment().isAfter(moment(confirmedTimeStamp).add(1, 'day').startOf('day'));
};
